export function NotFoundPage() {
  return (
    <section className="not-found">
      <p className="eyebrow">404</p>
      <h1>Page not found</h1>
      <p>The page you're looking for may have moved or no longer exists.</p>
      <a className="button" href="/">Return home</a>
    </section>
  );
}
